import React from 'react';
import { Tooltips } from '@ftdata/styleguide';
import DefaultIcon from '../defaultIcon';
import { useTranslation } from 'react-i18next';
import { ReactComponent as StreetView } from '../../../assets/svgs/location-pin-rotate.svg';

interface StreetvViewParams {
    lat_lng: number[];
}

const IconStreetView = <StreetView />;

const StreetViewIcon = ({ lat_lng }: StreetvViewParams): JSX.Element => {
    const { t } = useTranslation('114');

    const open = (event: React.MouseEvent<HTMLDivElement>) => {
        event.stopPropagation();
        const url = `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${lat_lng[0]},${lat_lng[1]}`;
        window.open(url, '_blank');
    };
    return (
        <Tooltips position="left" text={t('show_on_street_view').toString()}>
            <DefaultIcon onClick={open} icon={IconStreetView} />
        </Tooltips>
    );
};

export default StreetViewIcon;
